module.exports = __webpack_public_path__ + "img/palmar-resort-3.e47f7a67.jpg";